// KWF Admin shell: 260px dark teal sidebar + thin topbar + scrolling content.
// Used as a layout route so the sidebar stays mounted when moving between
// /dashboard/* and the listing and detail pages that live at top-level URLs.
import React, { useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { AuthWrapper } from "../AuthWrapper";
import Sidebar from "./Sidebar";
import AdminTopbar from "./AdminTopbar";
import "./admin/admin-ui.css";

const AdminShell = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const { pathname } = useLocation();
  return (
    <AuthWrapper>
      <div className={`ad-app${menuOpen ? " open" : ""}`}>
        {menuOpen && <div className="ad-side-overlay" onClick={() => setMenuOpen(false)} />}
        <Sidebar />
        <div className="ad-main">
          <AdminTopbar onBurger={() => setMenuOpen((v) => !v)} />
          {/* Keyed so a new page starts at the top of the scroll area. */}
          <div className="ad-content" key={pathname}>
            <Outlet />
          </div>
        </div>
      </div>
    </AuthWrapper>
  );
};

export default AdminShell;
